import React, { useState } from 'react';
import { compose } from 'redux';
import { usePagination, withPaginate } from '@contexts/Paginate/PaginateContext';
import DataTable from '@components/DataTable';
import { Box, Card, Chip, Link, Stack, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import rootApi from '@utils/baseAPI/WrapperApi';
import { convertObjectToUrlParam } from '@utils/urls';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import StatusLabel from '@page/Common/StatusLabel';
import DialogBindTariff from './Dialogs/DialogBindTariff';
import DialogUnbindTariff from './Dialogs/DialogUnBindTariff';
import FilterTable from './FilterTable';
import moment from 'moment/moment';

const ListDepot = () => {
  const { t } = useTranslation(['admin']);
  const navigate = useNavigate();
  const [openDialogBlind, setOpenDialogBlind] = useState(false);
  const [openDialogUnBlind, setOpenDialogUnBlind] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const handleOpenBlindTariff = (d) => {
    setOpenDialogBlind(true);
    setSelectedRow(d);
  };
  const handleOpenUnBlindTariff = (d) => {
    setOpenDialogUnBlind(true);
    setSelectedRow(d);
  };
  const getColumns = () => {
    return [
      {
        accessor: 'depot_name',
        Header: `${t('depot.depot_name')}`
      },
      { accessor: 'depot_code', Header: `${t('depot.depot_code')}` },
      {
        accessor: (d) => {
          return 'Công Cộng';
        },
        Header: `${t('depot.depot_type')}`
      },
      { accessor: 'number_connector_available', Header: `${t('depot.depot_connector')}` },
      { accessor: 'partner_response.name', Header: `${t('depot.partner')}` },
      // { accessor: 'latitude', Header: `${t('depot.latitude')}` },
      // { accessor: 'longitude', Header: `${t('depot.longitude')}` },
      { accessor: 'depot_pic', Header: `${t('depot.depot_pic')}` },
      {
        accessor: 'depot_address',
        Header: `${t('depot.address')}`
      },
      {
        accessor: (d) => {
          return (
            <>
              {d?.has_car_charge ? (
                <StatusLabel label="Có" color="success" />
              ) : (
                <StatusLabel label="Không" color="warning" />
              )}
            </>
          );
        },
        Header: `${t('depot.depot_has_car')}`
      },
      {
        accessor: (d) => {
          return d.tariff_active?.name;
        },
        Header: `${t('depot.tariff_active')}`
      },
      {
        accessor: (d) => {
          const binds = d?.tariff_binds || [];
          if (binds.length === 0) return <Typography variant="body2" color="text.disabled">—</Typography>;
          return (
            <Stack direction="row" flexWrap="wrap" gap={0.5}>
              {binds.map((t) => {
                const isActive = d?.tariff_active?.id === t.id;
                return (
                  <Chip
                    key={t.id}
                    label={t.name}
                    size="small"
                    color={isActive ? 'success' : 'default'}
                    variant={isActive ? 'filled' : 'outlined'}
                    sx={{ fontSize: '0.7rem', height: 22 }}
                  />
                );
              })}
            </Stack>
          );
        },
        Header: `${t('depot.tariff_blinds')}`
      },
      {
        accessor: (d) => {
          return (
            <Stack direction="row" gap={0.5} flexWrap="wrap">
              <Chip
                label="Gán giá"
                size="small"
                onClick={() => handleOpenBlindTariff(d)}
                sx={{
                  fontSize: '11px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  bgcolor: '#2D9764',
                  color: '#fff',
                  '&:hover': { bgcolor: '#247a52' }
                }}
              />
              {d?.tariff_binds?.length > 0 && (
                <Chip
                  label="Gỡ giá"
                  size="small"
                  onClick={() => handleOpenUnBlindTariff(d)}
                  sx={{
                    fontSize: '11px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    bgcolor: '#FA5050',
                    color: '#fff',
                    '&:hover': { bgcolor: '#d63c3c' }
                  }}
                />
              )}
            </Stack>
          );
        },
        Header: `Hành động`
      }
    ];
  };
  const [open, setOpen] = React.useState(false);
  const [dataFilter, setDataFilter] = React.useState();
  const [flagSearch, setFlagSearch] = React.useState(false);
  const [qStrs, setQStrs] = React.useState('1=1');
  const { page, pageSize } = usePagination();
  const currentPage = parseInt(page - 1, 10);

  let { data, isLoading, refetch, error, isSuccess } = useQuery(
    ['admin-all-depots', page, pageSize],
    () => rootApi.get(`/depots?page=${currentPage}&size=${pageSize}&${qStrs}`)
  );

  React.useEffect(() => {
    setQStrs(convertObjectToUrlParam(dataFilter));
  }, [dataFilter]);

  React.useEffect(() => {
    refetch();
  }, [flagSearch]);

  return (
    <>
      <Card>
        <Box width="100%" overflow="auto" paddingX={2}>
          <h2 style={{ fontSize: '20px', fontWeight: 700 }}>Quản lý cấu hình giá cho trạm</h2>
          <FilterTable
            dataFilter={dataFilter}
            onChange={setDataFilter}
            flagSearch={flagSearch}
            setFlagSearch={setFlagSearch}
            depots={data?.data.data}
          />
          <DataTable
            style={{ marginTop: '10px' }}
            columns={getColumns({
              refetch,
              setOpen
            })}
            data={data?.data.data || []}
            total={data?.data?.page?.total_elements || 0}
            loading={isLoading}
            error={error}
            isSuccess={isSuccess}
            tableName="Quản lý trạm sạc"
          />
          <DialogBindTariff
            open={openDialogBlind}
            setOpen={setOpenDialogBlind}
            refetch={refetch}
            depot={selectedRow}
          />
          <DialogUnbindTariff
            open={openDialogUnBlind}
            setOpen={setOpenDialogUnBlind}
            refetch={refetch}
            depot={selectedRow}
          />
        </Box>
      </Card>
    </>
  );
};
export default compose(withPaginate)(ListDepot);
